import type { DatasetIconProps } from "./DatasetIcon.type";

import { RiCompasses2Fill, RiCompasses2Line } from "react-icons/ri";

const CartesianIcon = ({ filled }: DatasetIconProps) => {
  return filled ? <RiCompasses2Fill /> : <RiCompasses2Line />;
};

export default CartesianIcon;
